// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__w6pyO","icon":"ThemeToggle_icon__PPH7A","select":"ThemeToggle_select__kA+rU"};